<main>
	<h1>Registro exitoso</h1>
</main>
